import type { AssistantThinkingKey } from './runPresentation';

const STORAGE_KEY = 'scarlet-assistant-thinking-v1';

export function readAssistantThinkingPreference(): AssistantThinkingKey {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'reasoning' ? 'reasoning' : 'default';
  } catch {
    return 'default';
  }
}

export function writeAssistantThinkingPreference(value: AssistantThinkingKey): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Keep the in-memory selection usable when storage is blocked.
  }
}
